//@flow
import myOrganizationsSearchActions from './myOrganizationsSearchActions';
import type {action} from "../../../services/flowTypes/appFlowTypes";
import type {organizationsSearch} from "../../../services/flowTypes/dataFlowTypes";

type reducerAction = action;
const initialState = {
  name: '',
  count: 10,
  offset: 0,
  status: 'ACTIVE'
};


const myOrganizationsSearchReducer = (state:organizationsSearch = initialState, action:reducerAction) => {
  const newState = Object.assign({}, state);
  switch (action.type) {
    case myOrganizationsSearchActions.MY_ORGANIZATIONS_SEARCH_INIT_STATE_SET:
      return initialState;
    case myOrganizationsSearchActions.MY_ORGANIZATIONS_SEARCH_PROP_UPDATE:
      return {...newState, ...action.value};
    case myOrganizationsSearchActions.MY_ORGANIZATIONS_SEARCH_PROP_DELETE:
      for (let i=0; i < action.value.length; i++) {
        delete newState[action.value[i]];
      }
      return newState;
    default:
      return state;
  }
};

export default myOrganizationsSearchReducer;
